import { People } from '@mui/icons-material';
import { CircularProgress, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BarChart from './BarChart';
import { GET_TOP_CUSTOMERS } from 'src/apiService/apiDeclaration';
import { showErrorTost } from 'src/constants';
import { t } from 'i18next';

const ChartSection = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    setLoading(true);
    try {
      let resp = await GET_TOP_CUSTOMERS();
      setData(resp.data);
    } catch (error) {
      console.log(error);
      showErrorTost('Error generating Graphs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return loading ? (
    <Container
      container
      sx={{ width: '100%', height: '20vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <CircularProgress />
    </Container>
  ) : (
    <Grid container xs={12} gap={4} mb={4}>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <People sx={{ fontSize: '2.5rem', color: '#acd629' }} />
        <Typography variant="h4">{t('dashboard.topCustomers')}</Typography>
      </Grid>
      <Grid item xs={12} md={5.8} className="card2" sx={{ p: 2, borderRadius: '25px', bgcolor: 'white' }}>
        <Typography variant="h5" sx={{ ml: 2, mb: 1 }}>
          {t('dashboard.byTotalAmount')}
        </Typography>
        <BarChart
          data={data?.topByTotalAmount}
          label={t('dashboard.TotalAmount')}
          xLabel={t('common.customers')}
          yLabel={t('dashboard.TotalAmount')}
          valueKey={'totalAmount'}
        />
      </Grid>
      <Grid item xs={12} md={5.8} className="card2" sx={{ p: 2, borderRadius: '25px', bgcolor: 'white' }}>
        <Typography variant="h5" sx={{ ml: 2, mb: 1 }}>
          {t('dashboard.byTotalVolume')}
        </Typography>
        <BarChart
          data={data?.topByTotalConcrete}
          label={t('dashboard.TotalVolume')}
          xLabel={t('common.customers')}
          yLabel={t('dashboard.TotalVolume')}
          valueKey={'totalConcrete'}
        />
      </Grid>
      <Grid item xs={12} md={5.8} className="card2" sx={{ p: 2, borderRadius: '25px', bgcolor: 'white' }}>
        <Typography variant="h5" sx={{ ml: 2, mb: 1 }}>
          {t('dashboard.byTotalOrders')}
        </Typography>
        <BarChart
          data={data?.topByOrderCount}
          label={t('dashboard.TotalOrders')}
          xLabel={t('common.customers')}
          yLabel={t('dashboard.TotalOrders')}
          valueKey={'orderCount'}
        />
      </Grid>
    </Grid>
  );
};

export default ChartSection;
